/** Class names that keep a Mantine Drawer below the app header. See app-theme.css. */
export const shellDrawerClassNames = {
  inner: 'app-shell-drawer-inner',
  content: 'app-shell-drawer-content',
} as const;
